<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>运营管理</a-breadcrumb-item>
    <a-breadcrumb-item>添加视频号达人</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 添加表单 -->
   <div style="margin-top: 50px;">
  <a-form 
  :model="formState" 
  :label-col="{ span: 8 }" 
  :wrapper-col="{ span: 4 }"
  >
    <a-form-item label="服务商ID" name="provider_id" :rules="[{ required: true, message: '请输入' }]">
      <a-input v-model:value="formState.provider_id"  placeholder="请输入"/>
    </a-form-item>

    <a-form-item label="视频号ID" name="wx_finder_id" :rules="[{ required: true, message: '请输入' }]">
      <a-input v-model:value="formState.wx_finder_id"  placeholder="请输入"/>
    </a-form-item>

    <a-form-item label="视频号名称" name="name" :rules="[{ message: '请输入' }]">
      <a-input v-model:value="formState.name" placeholder="请输入" />
    </a-form-item>

    <a-form-item :wrapper-col="{ offset: 8, span: 16 }">
      <a-button type="primary" html-type="submit" @click="touchSubmit">提交</a-button>
    </a-form-item>
  </a-form>
</div>
     <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
</template>
<script setup>
import { reactive} from 'vue'
import { ref } from 'vue'
import { message } from 'ant-design-vue' // 需要引入 message
import { finderProviderDarenSave } from '@/api/copyright.js'
import Loading from '@/components/Loading'


// 加载
let isLoading = ref(false)
// 表单状态
const formState = reactive({
  provider_id: undefined,
  wx_finder_id: undefined,
  name: undefined
});
// 提交
function touchSubmit () {
    isLoading.value = true
    const params = {
      provider_id: formState.provider_id,
      wx_finder_id: formState.wx_finder_id,
      name: formState.name
    }
    finderProviderDarenSave(params).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        // 重置表单状态
        formState.provider_id = undefined
        formState.wx_finder_id = undefined
        formState.name = undefined
        message.success('提交成功')
      } else {
        message.error(res.message || msg)
      }
    })
    }
</script>